import React, { useState } from 'react'
import { Tooltip, IconButton, TableCell, TableRow } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Delete from './Delete'
import DownloadIcon from '@mui/icons-material/Download'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)

  const { taxYear, company, name } = data.importData

  // Filename for downloading CP58 form
  const fileName = `CP58_${taxYear}_${company}_${name}.pdf`

  return (
    <>
      <TableRow>
        <TableCell>{taxYear}</TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>{company}</TableCell>
        <TableCell>
          <a
            href={data.cp58.uploadPath}
            download={fileName}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Tooltip title='Download CP58'>
              <IconButton>
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          </a>
        </TableCell>
        <TableCell>
          <Tooltip title='Delete'>
            <IconButton onClick={() => setOpenDelete(true)}>
              <DeleteOutlinedIcon size='small' />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
    </>
  )
}

export default Row
